module.exports = __webpack_public_path__ + "assets/img/feature-img3-9dd5dc41.jpg";